import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Layout, { RouteGuard } from "@/components/Layout";
import { LocaleProvider } from "@/lib/i18n";
import { ThemeProvider } from "@/lib/theme";
import { BrandingProvider } from "@/lib/branding";
import Login from "@/pages/Login";
// CustomerERP Faz 0 — yalnız Kontrol Paneli, Kullanıcılar & Yetkiler, Sistem
// Ayarları, Audit Log ve Yedekleme sayfaları route olarak kayıtlı.
// MetaERP business sayfaları (Ar-Ge, Formüller, Fiyat Teklifi, Proforma, GMP,
// Katalog, Yönetim Paneli, Kalite, Eğitim, Geri Çağırma, Karantina,
// İzlenebilirlik, Regülasyon, Satış Siparişleri, Muhasebe, Müşteriler,
// Envanter, Personel …) dosya olarak korunur ancak route'ta YOKTUR; doğrudan
// URL erişimi Kontrol Paneli'ne yönlendirilir.
import HomeDashboard from "@/pages/HomeDashboard";
import { SettingsPage } from "@/pages/System";
import { UsersPage } from "@/pages/Users";
import AuditLogPage from "@/pages/AuditLog";
import BackupPage from "@/pages/BackupPage";
import CustomersPage from "@/pages/Customers";
import CustomerDetailPage from "@/pages/CustomerDetail";
import ProductsPage from "@/pages/Products";
import ProductDetailPage from "@/pages/ProductDetail";
import StockPage from "@/pages/Stock";
import MaterialStockPage from "@/pages/MaterialStock";
import SalesOrderListPage from "@/pages/SalesOrderList";
import SalesOrderFormPage from "@/pages/SalesOrderForm";
import SalesOrderDetailPage from "@/pages/SalesOrderDetail";
import { PurchasingPage } from "@/pages/System";
import ShippingPage from "@/pages/Shipping";
import { SuppliersPage } from "@/pages/MasterData";
import { RequestsPage, FinancePage } from "@/pages/Muhasebe";
import CustomerServicePage from "@/pages/CustomerService";
import CatalogPage from "@/pages/Catalog";
import PersonnelPage from "@/pages/Personnel";
import SupportsPage from "@/pages/Supports";
import MonthlyReportsPage from "@/pages/MonthlyReports";
import PdfPreviewDialog from "@/components/PdfPreviewDialog";
import AutoTooltip from "@/components/AutoTooltip";
import ErrorBoundary from "@/components/ErrorBoundary";
import TraceabilityCenter from "@/pages/TraceabilitySearch";
import PublicTracePage from "@/pages/PublicTrace";

function Protected({ children, moduleKey }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{moduleKey ? <RouteGuard moduleKey={moduleKey}>{children}</RouteGuard> : children}</Layout>;
}

function App() {
  return (
    <BrandingProvider>
    <AuthProvider>
      <LocaleProvider>
      <ThemeProvider>
      <BrowserRouter>
        <ErrorBoundary>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/trace/:token" element={<PublicTracePage />} />
          <Route path="/traceability" element={<Protected moduleKey="traceability"><TraceabilityCenter /></Protected>} />
          <Route path="/" element={<Protected moduleKey="dashboard"><HomeDashboard /></Protected>} />
          <Route path="/customers" element={<Protected moduleKey="customers"><CustomersPage /></Protected>} />
          <Route path="/customers/:id" element={<Protected moduleKey="customers"><CustomerDetailPage /></Protected>} />
          <Route path="/sales-orders" element={<Protected moduleKey="sales_orders"><SalesOrderListPage /></Protected>} />
          <Route path="/sales-orders/new" element={<Protected moduleKey="sales_orders"><SalesOrderFormPage /></Protected>} />
          <Route path="/sales-orders/:id" element={<Protected moduleKey="sales_orders"><SalesOrderDetailPage /></Protected>} />
          <Route path="/sales-orders/:id/edit" element={<Protected moduleKey="sales_orders"><SalesOrderFormPage /></Protected>} />
          <Route path="/shipping" element={<Protected moduleKey="shipments"><ShippingPage /></Protected>} />
          <Route path="/purchasing" element={<Protected moduleKey="purchasing"><PurchasingPage /></Protected>} />
          <Route path="/suppliers" element={<Protected moduleKey="suppliers"><SuppliersPage /></Protected>} />
          <Route path="/customer-service" element={<Protected moduleKey="customer_service"><CustomerServicePage /></Protected>} />
          <Route path="/requests" element={<Protected moduleKey="requests"><RequestsPage /></Protected>} />
          <Route path="/catalog" element={<Protected><CatalogPage /></Protected>} />
          <Route path="/supports" element={<Protected><SupportsPage /></Protected>} />
          <Route path="/personnel" element={<Protected moduleKey="personnel"><PersonnelPage /></Protected>} />
          <Route path="/finance" element={<Protected moduleKey="finance"><FinancePage /></Protected>} />
          <Route path="/monthly-reports" element={<Protected moduleKey="finance"><MonthlyReportsPage /></Protected>} />
          <Route path="/products" element={<Protected moduleKey="products"><ProductsPage /></Protected>} />
          <Route path="/products/:id" element={<Protected moduleKey="products"><ProductDetailPage /></Protected>} />
          <Route path="/stock" element={<Protected moduleKey="inventory"><StockPage /></Protected>} />
          <Route path="/stock/lots" element={<Protected moduleKey="inventory"><StockPage /></Protected>} />
          <Route path="/material-stock" element={<Protected moduleKey="inventory"><MaterialStockPage /></Protected>} />
          <Route path="/users" element={<Protected moduleKey="users"><UsersPage /></Protected>} />
          <Route path="/settings" element={<Protected moduleKey="settings"><SettingsPage /></Protected>} />
          <Route path="/audit-log" element={<Protected moduleKey="admin_only"><AuditLogPage /></Protected>} />
          <Route path="/backup" element={<Protected moduleKey="admin_only"><BackupPage /></Protected>} />
          {/* Tanımsız / kaldırılmış MetaERP URL'leri → Kontrol Paneli */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </ErrorBoundary>
        <PdfPreviewDialog />
        <AutoTooltip />
      </BrowserRouter>
      </ThemeProvider>
      </LocaleProvider>
    </AuthProvider>
    </BrandingProvider>
  );
}
export default App;
